import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: 'Tapping into the Source',
  date: new Date(2023, 6, 16),
  img: '/img/leprechaun.jpeg',
  tracks: [
    {
      title: 'Neener Neener',
      src: '/songs/2023-07-16/neener_neener.mp3',
    },
    {
      title: 'Word Travels Fast',
      src: '/songs/2023-07-16/word_travels_fast.mp3',
    },
    {
      title: 'Confluent Angles',
      src: '/songs/2023-07-16/confluent_angles.mp3',
    },
    {
      title: 'S.E.T.I',
      src: '/songs/2023-07-16/seti.mp3',
    },
    {
      title: 'Turkey Vulture Radish',
      src: '/songs/2023-07-16/turkey_vulture_radish.mp3',
    },
    {
      title: 'Faerie Spinkles',
      src: '/songs/2023-07-16/faerie_sprinkles.mp3',
    },
    {
      title: 'Do Tell',
      src: '/songs/2023-07-16/do_tell.mp3',
    },
    {
      title: 'Uh, Oh! Oh, No',
      src: '/songs/2023-07-16/uh_oh_oh_no.mp3',
    },
    {
      title: 'Somehow Safely Landing the Plane',
      src: '/songs/2023-07-16/somehow_safely_landing_the_plane.mp3',
    },
    {
      title: 'Veritable Fruit Salad',
      src: '/songs/2023-07-16/veritable_fruit_salad.mp3',
    },
    {
      title: 'Listen to the Beat',
      src: '/songs/2023-07-16/listen_to_the_beat.mp3',
    },
    {
      title: 'Don\'t Give me Your Blues',
      src: '/songs/2023-07-16/dont_give_me_your_blues.mp3',
    },
    {
      title: 'Leprechaun',
      src: '/songs/2023-07-16/leprechaun.mp3',
    },
  ]
}
export default album;